module.exports = __webpack_public_path__ + "static/media/masjid_ummu_kulthum_hilal2.1d053857.webp";